import { createContext, use, type Context } from 'react';

import { type Category } from '@/schemas/category';
import { type School } from '@/schemas/school';

export type SchoolContextValue = {
  schools: School[];
  isLoading: boolean;
  error: Error | null;
  schoolId: string | null;
  setSchoolId: (id: string | null) => void;
  categories: Category[];
};

export const SchoolContext: Context<SchoolContextValue | null> = createContext<SchoolContextValue | null>(null);

export function useSchoolContext(): SchoolContextValue {
  const context = use(SchoolContext);
  if (!context) {
    throw new Error(
      'useSchoolContext must be used within a SchoolProvider. Make sure to wrap your component tree with <SchoolProvider>'
    );
  }
  return context;
}
